// extracted by mini-css-extract-plugin
export default {"container":"CookiesBanner_container__fK9xo","explication":"CookiesBanner_explication__m4Wnd"};